import React, {useEffect} from 'react';
import InputMap1  from './partials/input-map1';
import drawState  from './enums/drawState';
import { pointsMapReseted } from './action';
import { Redirect } from "react-router-dom";
import Pages from './enums/pages';
import { PrevSettings, PrevSettingsContent, PrevSettingsItem } from './components/prevSettings';
//import Alert from './components/alert';
import { AsideLayout } from './components/asideLayout';
import { pointAdded, pointRemoved } from './action';
import { MapButton } from './components/mapButton';
import ReactGA from "react-ga4";

export function Points(props) {
  const [fields, setFields] = React.useState({
        "captcha": '',
        "arePointsDataCompleted": getArePointsDataCompleted(),
        "pointsCount": props.store.getState().trajectoryPoints?.points?.length ?? 0,
        "start": props.store.getState().trajectoryPoints?.start,
        "end": props.store.getState().trajectoryPoints?.end
  });
  const [errors, setErrors] = React.useState({captcha: ''});  
  const [actualDrawState, setActualDrawState] =  React.useState(drawState.MOVEMAP); 
  const [redirect, setRedirect] = React.useState(areRoverDataComplete()? Pages.Points: Pages.Rover);    
  const [captchaImg, setCaptchaImg] = React.useState(null);   
  const [drawScenario] = React.useState(createDrawScenarioWithReduxAction);   
  const [removeScenario] = React.useState(createRemoveScenarioWithReduxAction);

  function getArePointsDataCompleted() {
    let trajectoryPoints = props.store.getState().trajectoryPoints;
    return trajectoryPoints?.start && trajectoryPoints?.end && trajectoryPoints?.points
  }

  useEffect(()=>{
    loadImage();
    setActualDrawState(getInitialDrawState());
    const unsubscribe = subscribeStateToReduxStore();
    if (!arePointsDataAlreadySet())
      initReduxStore(props.store);

    document.title = "Points | Route Planning";

    return () => {
      unsubscribe();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }, []);

  function initReduxStore(store) {
    store.dispatch(pointAdded({captcha:''}));
  }

  function subscribeStateToReduxStore() {
    return props.store.subscribe(() => {

      let trajectoryPoints = props.store.getState().trajectoryPoints;
      let formFields = {};
      formFields["start"] = trajectoryPoints?.start;
      formFields["points"] = trajectoryPoints?.points;
      formFields["end"] = trajectoryPoints?.end;
      formFields["captcha"] = trajectoryPoints?.captcha;
      formFields["arePointsDataCompleted"] = trajectoryPoints.start && trajectoryPoints.end && trajectoryPoints.points;
      formFields["pointsCount"] = trajectoryPoints?.points && trajectoryPoints.points.length > 0 ? trajectoryPoints.points.length : 0;
      setFields(formFields);
    });
  }

  function arePointsDataAlreadySet() {
    return props.store.getState()?.trajectoryPoints && !isObjectEmpty(props.store.getState()?.trajectoryPoints) && props.store.getState()?.trajectoryPoints.captcha !== undefined && props.store.getState()?.trajectoryPoints.captcha !== null;
  }

  function areRoverDataComplete() {
    let rover = props.store.getState().rover;
    return rover.length && rover.turningRadius && rover.wheelDistance;
  }

  if (redirect === Pages.Points)
  {
    let positionOfRotationAxis = props.store.getState().rover.positionOfRotationAxis;
    let positionOfGnsReceiver = props.store.getState().rover.positionOfGnsReceiver;
    let points = [];

    if (props.store.getState().trajectoryPoints.start)
      points.push(props.store.getState().trajectoryPoints.start);
    points = points.concat(props.store.getState().trajectoryPoints.points);
    if (props.store.getState().trajectoryPoints.end)
      points.push(props.store.getState().trajectoryPoints.end);

    return <>
      {/* [BLOCK] Map */}
      <div className="interactive-block">
        <div className = "map-toolbar">
          <MapButton isActive={actualDrawState === drawState.MOVEMAP} onClick={() => setActualDrawState(drawState.MOVEMAP)}>
            <i className='icon icon-hand-paper'></i>
          </MapButton>
          <MapButton isActive={actualDrawState === drawState.START} onClick={() => setActualDrawState(drawState.START)}>
            <img className='img-icon mr-2' src='./icon-start.png' alt='Start' /> Start
          </MapButton>
          <MapButton isActive={actualDrawState === drawState.POINTS} onClick={() => setActualDrawState( drawState.POINTS)}>
            <img className='img-icon mr-2' src='./icon-point.png' alt='Waypoints' /> Waypoints
          </MapButton>
          <MapButton isActive={actualDrawState === drawState.END} onClick={() => setActualDrawState(drawState.END)}>
            <img className='img-icon mr-2' src='./icon-end.png' alt='End'/> End
          </MapButton>
          <MapButton isActive={false} onClick={(e) => { props.store.dispatch(pointsMapReseted()); }} className='btn-danger'>
            <i className='icon icon-trash-alt mr-2'></i> Clear map
          </MapButton>
        </div>
        <InputMap1 /*drawStateHandler = {drawStateHandler}*/ drawScenario = {drawScenario} store = {props.store} 
          drawState = {actualDrawState} points = {points}
          getFeatureIdBystate = {getFeatureIdBystate} removeScenario = {removeScenario} getPreventUnorientedPoint = {getPreventUnorientedPoint}
          linesBetweenPoints = {true}  afterFeatureAdded = {afterFeatureAdded}
        />
        <PrevSettings>
          <PrevSettingsContent header ={"Rover"} link = {Pages.Rover}>
            <PrevSettingsItem name={"Wheel Distance"} value={props.store.getState().rover.wheelDistance} unit={"m"}/>
            <PrevSettingsItem name={"Length"} value={props.store.getState().rover.length - 1} unit={"m"}/>
            <PrevSettingsItem name={"Turning radius"} value={props.store.getState().rover.turningRadius} unit={"m"}/>
            {positionOfRotationAxis && <PrevSettingsItem name={"Position of axis of rotation"} value={positionOfRotationAxis} unit={"m"}/>}
            {positionOfGnsReceiver && <PrevSettingsItem name={"Position of GNSS receiver"} value={positionOfGnsReceiver} unit={"m"}/>}
          </PrevSettingsContent>
        </PrevSettings>
      </div>
      {/* [BLOCK] Aside */}
      <AsideLayout header = {"Define field"} >
        <div className="mb-6">
          <h2 className="h4-font-size subtitle">1) Define start point</h2>
          <div id="startPointMarker" className={`map-step ${isFeatureDone(drawState.START)}`}>
            <i className="icon icon-check pr-2 mb-2" />
            <span>Start point</span>
          </div>
        </div>
        <div className="mb-6">
          <h2 className="h4-font-size subtitle">2) Define waypoints</h2>
          <div className="map-step info">
            <span id="obstaclesCount" className="pr-2">{fields["pointsCount"]}</span>
            <span>Waypoints</span>
          </div>
        </div>
        <div className="mb-7">
          <h2 className="h4-font-size subtitle">1) Define end point</h2>
          <div id="endPointMarker" className={`map-step mb-2 ${isFeatureDone(drawState.END)}`}>
            <i className="icon icon-check pr-2" />
            <span>End point</span>
          </div>
        </div>
        
        {captchaImg &&
          <div className="captcha-container">
            <div className="captcha-image">
              <img id="img-captcha" title = "Can't read? Click to change another image." aria-label = "Can't read? Click to change another image."  src = {captchaImg} onClick={() =>loadImage()}/>
            </div>
            <div className="captcha-input">
              <label htmlFor="captcha-input" className='required'>Captcha</label>
              <div className="form-group font-size-lg">
                <input type="text" id='captcha-input' className="form-control mb-1" placeholder="Enter captcha code" maxLength={4} 
                  value = {fields["captcha"]} error = {errors["captcha"]}
                  onChange ={(e) => props.store.dispatch(pointAdded({captcha:e.target.value}))}
                  onKeyPress={handleCaptchaKeypress}
                />
              </div>
              {errors["captcha"] && <span class="invalid-feedback  input-validation-error">{errors["captcha"]}</span>}   
            </div>
          </div>
        }

        <button type="button" className= {`btn w-100 mx-0 ${!fields["arePointsDataCompleted"] || objectPropsHasValues(errors) ? "disabled" : ""}`}  
          onClick={async () => {await generateRoute();} }   
        >Generate route
        </button>  
      </AsideLayout>
      <div className='alerts-container'>
        {/*error && <Alert onClick={(e) => { setErrors(null)}} variant='danger'>{error}</Alert>*/}
      </div>
    </>
  }
  else
    return <Redirect to={redirect} />

  async function generateRoute() {
    let captchaOk = await processCaptcha();
    if (captchaOk && handleValidation() && fields["arePointsDataCompleted"] && !objectPropsHasValues(errors)) {
      setRedirect(Pages.PointsResult);
    }
  }

  function handleCaptchaKeypress(e) {
    if (e.charCode === 13) {
      e.preventDefault();
      generateRoute();
    }
  };

  function handleValidation() {
    let error = {};
    return (((captchaImg === null || captchaImg === undefined) || checkValueIsSetOrAddError("captcha", error, true)));
  }

  function afterFeatureAdded() {
    setActualDrawState(drawState.MOVEMAP)
  }

  function checkValueIsSetOrAddError(propertyName, error, setState = false) {
    let result = true;
    if(!fields[propertyName]){
      error[propertyName] = "Cannot be empty";
      result = false;
    }
    
    if (setState && !isObjectEmpty(error))
      setErrors(error);
    return result;
  }

  async function processCaptcha() {
    if (captchaImg)
      return true;

    return (!await loadImage());
  }

  function createDrawScenarioWithReduxAction() {
    let drawScenario = new Map();
    //start pro prvni bod..end nebude
    drawScenario.set(drawState.START, (point) => { 
        return pointAdded({start: point})
    });
    drawScenario.set(drawState.POINTS, (point) => { 
      return pointAdded({points: point});
    });

    drawScenario.set(drawState.END, (point) => { 
        return pointAdded({end: point});
    });
    return drawScenario;    
  }

  function createRemoveScenarioWithReduxAction() {
    let removeScenario = new Map();
    removeScenario.set(drawState.START, () => { 
        return pointAdded({start: null})
    });
    removeScenario.set(drawState.POINTS, (id) => { 
      return pointRemoved(id);
    });

    removeScenario.set(drawState.END, () => { 
        return pointAdded({end: null});
    });
    return removeScenario;    
  }

  function getFeatureIdBystate(myDrawState) {
    switch(myDrawState) {
      case drawState.START: return props.store.getState()?.trajectoryPoints?.start?.Id;
      case drawState.END: return  props.store.getState()?.trajectoryPoints?.end?.Id;
      default: return null;  
    }
  }

  function isFeatureDone(stepState) {
    return fields[stepState]? "done" : "";
  }

  /*function drawStateHandler(state) {
    let newState = {drawState:state};
    if (state === drawState.NONE)
      newState.drawing = false;
    this.setState(newState);
  }*/

  function getInitialDrawState() {
    let points = props.store.getState().trajectoryPoints.points;
    if (points && points.length >= 2) return drawState.END;
    if (points && points.length === 1) return drawState.POINTS;
    
    return drawState.START
  }

  function getPreventUnorientedPoint(myDrawState) {
    return myDrawState === drawState.START;
  }

  async function loadImage() {
    let response = await fetch('/api/Home/GetCaptchaImage',
    {
      mode: 'cors',
      credentials: 'include'
    });

    if (response.status === "204") return false;
    // console.log(response.text);
    let blob = await response.blob();
    setCaptchaImg(URL.createObjectURL(blob));
    return true;
  }

  function isObjectEmpty(obj) {
    return obj
    && Object.keys(obj).length === 0
    && Object.getPrototypeOf(obj) === Object.prototype
  } 

  function objectPropsHasValues(obj) {
    for (const key in obj) {
      if (obj[key])
      return true;
    }
    return false;
  } 
};